import React from "react";
import { Switch } from "react-router-dom";
import PrivateRoute from 'components/auth/PrivateRoute';
import Home from 'pages/heim/Home';
import Atkvaedi from 'pages/skraning/atkvaedi/Atkvaedi';
import AdsentAtkvaedi from 'pages/skraning/adsent-atkvaedi/AdsentAtkvaedi';
import BreytaAtkvaedi from 'pages/skraning/breyta-atkvaedi/BreytaAtkvaedi';
import Maelibord from "pages/tolfraedi/maelibord/Maelibord";
import Skoda from "pages/tolfraedi/skoda/Skoda";
import Urvinnslur from "pages/urvinnslur/Urvinnslur";
import Stillingar from "pages/stillingar/Stillingar";
import Profill from "pages/profill/Profill";
import Admin from "pages/admin/Admin";


export function Routes() {
  return (
    <Switch>
      <PrivateRoute exact path="/" component={Home}></PrivateRoute>
      <PrivateRoute path="/skraning/atkvaedi" component={Atkvaedi}></PrivateRoute>
      {/* <PrivateRoute path="/skraning/adsent-atkvaedi" component={AdsentAtkvaedi}></PrivateRoute> */}
      <PrivateRoute path="/skraning/fylgigogn-leidrett" component={BreytaAtkvaedi}></PrivateRoute>
      <PrivateRoute path="/tolfraedi/maelibord" component={Maelibord}></PrivateRoute>
      <PrivateRoute path="/tolfraedi/skoda" component={Skoda}></PrivateRoute>
      <PrivateRoute path="/urvinnslur" component={Urvinnslur}></PrivateRoute>
      <PrivateRoute path="/stillingar" component={Stillingar}></PrivateRoute>
      <PrivateRoute path="/profill" component={Profill}></PrivateRoute>
      <PrivateRoute path="/admin" component={Admin} role="utankjorfundarkerfi.admin"></PrivateRoute>
    </Switch>
  );
}